<div class="excel-download" [ngClass]="{ 'excel-ar-download': current_lang === 'ar' }">
    <!--- Dropdown option -->

    <!--- Down load icon -->
    <div class="download-excel-outer" *ngIf="
      tableData?.length !== 0 &&
      tableData &&
      allowExcelDownload
    ">
        <button class="download_excel" [disabled]="LockReport" *ngIf="!downloadLoading" (click)="downloadExcel()"
            matTooltip="{{ 'reports.download_excel' | translate }}" matTooltipPosition="above"><img *ngIf="!LockReport"
                src="../../../../../../assets/images/excel-icon.svg" />
            <img *ngIf="LockReport" src="../../../../../../assets/images/excel-icon-disable.svg" /></button>
        <span *ngIf="downloadLoading"><mat-spinner class="download-spinner"></mat-spinner></span>
    </div>
    <!--- Dropdown option -->
</div>

<div class="main-table">
    <table class="table" matSort (matSortChange)="onSortTable($event)">
        <thead>
            <tr>
                <ng-container *ngFor="let tableColumn of tableColumns">

                    <!-- Conditionally render <th> with or without mat-sort-header -->
                    <th *ngIf="tableColumn.isSortable; else noSort" mat-sort-header="{{ tableColumn.header }}"
                        [class.custom-bg-th]="tableColumn.border">

                        <ng-container *ngIf="tableColumn?.recordType; else otherColumn">
                                <span class="header_label record_type">
                                    {{ tableColumn?.columnName | translate }}
                                    <span class="">{{ tableColumn?.symbol | reportDataValueType : current_lang }}</span>
                                    <span class="record_type-text">({{ "reports.record_type" | translate }})</span>
                                </span>
                        </ng-container>

                        <ng-template #otherColumn>
                                <span class="header_label">
                                    {{ tableColumn?.columnName | translate }}
                                    <span class="text-transform-normal">{{ tableColumn?.symbol |
                                        reportDataValueType : current_lang }}</span>
                                </span>
                        </ng-template>
                    </th>

                    <!-- <th> without mat-sort-header -->
                    <ng-template #noSort>
                        <th [class.custom-bg-th]="tableColumn.border">
                            <ng-container *ngIf="tableColumn?.recordType; else otherColumnNoSort">
                                <div class="mat-column">
                                    <span class="header_label record_type">
                                        {{ tableColumn?.columnName | translate }}
                                        <span class="">{{ tableColumn?.symbol | reportDataValueType : current_lang }}</span>
                                        <span class="record_type-text">({{ "reports.record_type" | translate }})</span>
                                    </span>
                                </div>
                            </ng-container>

                            <ng-template #otherColumnNoSort>
                                <div class="mat-column">
                                    <span class="header_label">
                                        {{ tableColumn?.columnName | translate }}
                                        <span class="text-transform-normal">{{ tableColumn?.symbol |
                                            reportDataValueType : current_lang }}</span>
                                    </span>
                                </div>
                            </ng-template>
                        </th>
                    </ng-template>

                </ng-container>
            </tr>

        </thead>
        <tbody>
            <tr *ngFor="let element of tableData; let i = index"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                (click)="setExpadndColor(i)" [@detailExpand]="element.isOpen === 1 ? 'collapsed' : 'expanded'"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                [ngClass]="(expandedElement === element && !element['outlier'] ? 'example-expanded-row':'')"
                [ngClass]="{ hideTable: !showLoader }"
                [ngClass]="{'tr-parent': element.isParent, 'tr-child': !element.isParent}"
                [class.expand-hide]="element.isOpen === 1" [ngClass]="{'blur-content': element['NODATA']}">

                <td>
                    <div class="column-data align-items-center position-relative">
                        <!-- Expand Icon -->
                        <div class="expand-icon" [class.d-none]="!element.isDetail">
                            <mat-icon (click)="isChildOpen(element, i);
                            expandedElement =
                              expandedElement === element ? null : element
                          ">{{
                                expandedElement === element
                                ? "arrow_drop_down"
                                : current_lang === "ar"
                                ? "arrow_left"
                                : "arrow_right"
                                }}</mat-icon>
                        </div>
                        <div class="tooltip showonmap-column">
                            <!-- Column Name Text -->

                            <span class="column_entry" [attr.title]="element?.property_name"
                                 (click)="!iswarehouseReport ? panToMap(element, tableColumns[0].field, i, 'showOnMap', true) : null"
                                [ngClass]="{'link_item': (element?.lat && tableColumns[0]?.showOnMap && tableColumns[0]?.isAnchor && element.isParent && !iswarehouseReport)}">
                              <ng-container *ngIf="tableName !== 'projLandPrice' && element.isParent">{{element?.property_name }}</ng-container>
                              <ng-container *ngIf="tableName === 'projLandPrice' && element.isParent">{{element?.property_uid }}</ng-container>
                            </span>
                            <!-- Show On Map Icon -->
                            <span *ngIf="element.isParent && element?.lat" class="show_on_map"
                                [ngClass]="{'clicked_item': selectedIndex === ('' + goToPageNumber + i)}"
                                (click)="panToMap(element, tableColumns[0].field, i, 'showOnMap')"
                                matTooltip="{{'reports.show_on_map' | translate}}">
                                <mat-icon svgIcon="location" class="icon"></mat-icon>
                            </span>
                            <!-- Show On Map Loader -->
                            <span class="tenent_map_icon loader__"
                                *ngIf="(element?.lat || element?.tenants_lat_lon) && selectedIndex === ('' + goToPageNumber + i) && tenantLoading"
                                [ngClass]="{'clicked_item': tenantLoading && selectedIndex === ('' + goToPageNumber + i)}"><mat-spinner
                                    class="download-spinner"></mat-spinner></span>
                        </div>
                    </div>
                </td>
                <ng-container *ngIf="tableName === 'projLandPrice'">
                    <!-- <td>{{element?.property_uid ? element?.property_uid : '-'}}</td> -->
                    <td>{{element?.transaction_date ? element?.transaction_date : '-'}}</td>
                    <td>{{element?.price_type ? element?.price_type : '-'}}</td>
                    <td [innerHTML]="element?.value" class="custom-conditional-bg-td"></td>
                   <td >{{element?.transaction_area ? (element?.transaction_area | number: '1.0-1') : '-'}}</td>
                       <td [ngClass]="{'outlier-text': element['outlier']}">
                            {{element?.transaction_rate ? (element?.transaction_rate | number: '1.0-1') : '-'}}
                            <span class="outlier"
                                *ngIf="element['outlier'] && element?.transaction_rate">{{'reports.outlier' |
                                translate}}</span>
                        </td>
                   <td>{{element?.parcel_no ? element?.parcel_no : '-'}}</td>
                </ng-container>
                <ng-container *ngIf="tableName === 'projectPropertyPrices'">
                   <td>{{element?.parcel_no ? element?.parcel_no : '-'}}</td>
                    <!-- <td>{{element?.property_uid ? element?.property_uid : '-'}}</td> -->
                    <td>{{element?.transaction_date ? element?.transaction_date : '-'}}</td>
                    <td>{{element?.type ? element?.type : '-'}}</td>
                    <td>{{element?.price_type ? element?.price_type : '-'}}</td>
                    <!-- <td [innerHTML]="element?.value" class="custom-conditional-bg-td"></td> -->
                    <td [innerHTML]="element?.value" class="custom-conditional-bg-td"></td>
                    <td>{{element?.transaction_area ? (element?.transaction_area  | number: '1.0-1') : '-'}}</td>
                   <!-- <td>{{element?.transaction_rate ? element?.transaction_rate : '-'}}</td> -->
                    <td [ngClass]="{'outlier-text': element['outlier']}">
                        {{element?.transaction_rate ? (element?.transaction_rate | number: '1.0-1') : '-'}}
                        <span class="outlier"
                            *ngIf="element['outlier'] && element?.transaction_rate">{{'reports.outlier' |
                            translate}}</span>
                    </td>

                </ng-container>
                  <ng-container *ngIf="tableName === 'projectUnitPrices'">
                   <!-- <td>{{element?.property_uid ? element?.property_uid : '-'}}</td> -->
                    <td>{{element?.transaction_date ? element?.transaction_date : '-'}}</td>
                     <td>{{element?.type ? element?.type : '-'}}</td>
                    <td>{{element?.price_type ? element?.price_type : '-'}}</td>
                    <td [innerHTML]="element?.value" class="custom-conditional-bg-td"></td>
                    <!-- <td [innerHTML]="element?.value" class="custom-conditional-bg-td"></td> -->
                   <td>{{element?.transaction_area ? (element?.transaction_area | number: '1.0-1') : '-'}}</td>

                     <td [ngClass]="{'outlier-text': element['outlier']}">
                            {{element?.transaction_rate ? (element?.transaction_rate | number: '1.0-1') : '-'}}
                            <span class="outlier"
                                *ngIf="element['outlier'] && element?.transaction_rate">{{'reports.outlier' |
                                translate}}</span>
                        </td>
                   <td>{{element?.unit_uid ? element?.unit_uid : '-'}}</td>
                </ng-container>
            </tr>
            <tr *ngIf="!showLoader" style="height: auto;" class="loader-tr">
                <td style="padding: 0;" [attr.colspan]="tableColumns?.length">
                    <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
                </td>
            </tr>
        </tbody>
    </table>
    <!--- No Record Found -->
    <div class="data_unavail" *ngIf="(tableData?.length === 0 || !tableData) && showLoader">
        <span>
            {{"reports.dataComingSoon" | translate}}
        </span>
    </div>
    <!-- Table content blur start -->
    <div class="lock-table-row" *ngIf="LockReport">
        <img src="../../../../../../assets/images/Lock.png" alt="">
    </div>
</div>
<!--- Pagination -->
<div class="pagination-wrapper pagination-showing-count"
    *ngIf="tableData?.length !== 0 && tableData && !hidePagination">
    <ng-container *ngIf="show_step_count">
        <p *ngIf="!LockReport" [class.showingrecord-margin]="dataLength > 2">
            {{ "reports.Showing" | translate }} {{ startIndex }}
            {{ "reports.to" | translate }} {{ endIndex }}
            {{ "reports.outOf" | translate }}
            {{ dataLength | internationalNumber }}
            {{ "reports.records" | translate}}
        </p>
    </ng-container>
    <p *ngIf="LockReport" class="pb-2">
        <span class="contact-sale" (click)="openContactSales()">{{'contactSales' | translate }}</span>
        {{'to_unlock' | translate }} <ng-container *ngIf="dataLength > 3"> {{(dataLength
            - 3) | internationalNumber }} {{'rows_more'| translate}}</ng-container> <ng-container
            *ngIf="dataLength <= 3">{{'more_rows'|
            translate}}</ng-container>.
    </p>

    <mat-paginator *ngIf="dataLength > 20" [disabled]="!showLoader || LockReport" class="default-pagination"
        [length]="dataLength" [pageSize]="20" [pageSizeOptions]="[5, 10, 15, 25, 100]" [showFirstLastButtons]="true"
        (page)="onPageChange($event)" [hidePageSize]="true">
    </mat-paginator>

    <!-- Pagination input -->
    <div class="go-to-page d-flex align-items-center" *ngIf="dataLength > 20">
        <input class="go-to-page-input" type="number" [(ngModel)]="goToPageNumber" (change)="onGoToPage()"
            [disabled]="totalPages === 1 || !showLoader || LockReport" />
        <span class="oftext">of</span>
        <span>{{ totalPages }}</span>
    </div>
</div>

<!--- data cleaned Text -->
<div class="dataCleaned">
    <span>
        <ng-container *ngIf="showEstaterText">{{
            "reports.dataCleaned" | translate
            }}</ng-container>
    </span>

</div>
